import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { InfoDot } from './info-dot';
const useStyles = makeStyles({
    label: {
        alignItems: 'center',
        display: 'inline-flex',
        fontSize: 14,
        gap: 6
    }
});
// Label text with an optional info dot, rendered above a field or inline as a
// section heading. Styled to match MUI body text so it reads like other labels.
export const FieldLabel = ({ info, label }) => {
    const classes = useStyles();
    return (React.createElement("span", { className: classes.label },
        label,
        info && React.createElement(InfoDot, { info: info })));
};
